import React from 'react';
import { Modal } from 'antd';
import AlumlyButton from '../../../components/AlumlyButton';
import warningIcon from '../../../assets/images/warning.svg';

interface DeleteCustomerConfirmModalProps {
  isOpen: boolean;
  handleClose: () => void;
}
const WarningDeleteCustomerModel: React.FC<DeleteCustomerConfirmModalProps> = (props) => {
  const {
    isOpen, handleClose,
  } = props;
  return (
    <Modal
      open={isOpen}
      onCancel={() => handleClose()}
      footer={null}
      centered
    >
      <div style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={warningIcon} alt="" style={{ width: '70px', height: '70px' }} />
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 8,
        }}
        >
          <span style={{ fontWeight: 'bold' }}>Cannot delete the customer account from a </span>
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8,
        }}
        >
          <span style={{ fontWeight: 'bold' }}>customer with active status</span>
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 32,
        }}
        >
          <AlumlyButton width={380} onClick={() => handleClose()} label="rxv">
            Close
          </AlumlyButton>
        </div>
      </div>
    </Modal>
  );
};
export default WarningDeleteCustomerModel;
